// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"138":"profile","336":"tenantSettings","351":"tenant","646":"platform","933":"auth"}[chunkId] + ".js?" + {"138":"4e76abc9d8c301da","336":"7620b1a2ee919c2f","351":"f36a41579013c18f","646":"23870cc56c7e6943","933":"dc6a80de2f6adc58"}[chunkId] + "";
};